<div>
  <div class="row" *ngIf="errorMessage">
    <div class="col-12 m-t-md">
      <tmo-error-message-detail [errorMessage]="errorMessage"></tmo-error-message-detail>
    </div>
  </div>
  <div class="row m-t-lg">
    <div class="col-12" *ngIf="!digitalPlansView; else digitalPlansView">
      <p-accordion
        *ngIf="familyPlanData && familyPlanData.length > 0; else elseBlock"
        [multiple]="isCPS"
      >
        <p-accordionTab
          *ngFor="let family of familyPlanData; let familyIndex = index"
          [disabled]="disablePlanBlade"
          tmoRemoveRoleTab
          [ariaLabel]="family?.familyName"
          id="p-accordionTab-default-40_{{ familyIndex }}"
          [selected]="
            !disablePlanBlade &&
            (selectedPlanFamilyCode === family?.familyCode ||
              family?.planFamilySelected ||
              (!selectedPlanFamilyCode &&
                familyIndex === 0 &&
                selectedPlanFamilyCode !== grandfatheredConst &&
                !isBillingAddressConflict &&
                !isAccountSegmentationConflict)) &&
            !isNoPlanNeeded
          "
          class="fractional"
        >
          <p-header>
            <div class="row" *ngIf="isProductSelector && isAddAFan; else showSelectedPlan">
              <div class="col-9 col-md-9">
                <h6
                  class="title space"
                  [ngClass]="{
                    'alert-text':
                      (focusedTileId?.plansFromCart?.familyCode === family?.familyCode ||
                        selectedPlanFamilyCode === family?.familyCode) &&
                      !isNoPlanNeeded,
                  }"
                >
                  <i
                    *ngIf="
                      (focusedTileId?.plansFromCart?.familyCode === family?.familyCode ||
                        selectedPlanFamilyCode === family?.familyCode) &&
                      !isNoPlanNeeded
                    "
                    class="fa fa-check alert-icon def p-t-xs"
                  ></i>
                  {{ family?.familyName }}
                </h6>
                <p class="xsmall blade-desc" *ngIf="family?.description && isCPS">
                  {{ family?.description }}
                </p>
                <p
                  class="blade-desc alert-text"
                  [ngClass]="{
                    'alert-text':
                      (focusedTileId?.plansFromCart?.familyCode === family?.familyCode ||
                        selectedPlanFamilyCode === family?.familyCode) &&
                      !isNoPlanNeeded,
                  }"
                  *ngIf="
                    (focusedTileId?.plansFromCart?.familyCode === family?.familyCode ||
                      selectedPlanFamilyCode === family?.familyCode) &&
                    !isNoPlanNeeded
                  "
                >
                  {{ focusedTileId?.plansFromCart?.planOfferName }}
                </p>
                <p
                  class="blade-desc alert-text"
                  [ngClass]="{
                    'alert-text':
                      (focusedTileId?.plansFromCart?.familyCode === family?.familyCode ||
                        selectedPlanFamilyCode === family?.familyCode) &&
                      !isNoPlanNeeded,
                  }"
                  *ngIf="isCPS && selectedPlanFamilyCode === family?.familyCode"
                >
                  {{ selectedPlanName?.label }}
                </p>
                <p
                  class="blade-desc alert-text"
                  [ngClass]="{
                    'alert-text':
                      (focusedTileId?.plansFromCart?.familyCode === family?.familyCode ||
                        selectedPlanFamilyCode === family?.familyCode) &&
                      !isNoPlanNeeded,
                  }"
                  *ngIf="
                    !isAuthFlow &&
                    !disablePlanBlade &&
                    !isNoPlanNeeded &&
                    selectedPlanFamilyCode !== family?.familyCode
                  "
                >
                  {{ aemContent?.noPlanSelected }}
                </p>
              </div>
              <div
                class="col-md-2 d-none d-md-block n-padding-l text-end"
                *ngIf="selectedPlanFamilyCode === family?.familyCode && !isNoPlanNeeded"
              >
                <p class="lead m-t-xs">
                  {{ selectedPlanName?.monthlyPrice.displayValue | currency: 'USD' : 'symbol' }}
                </p>
                <p *ngIf="family?.familyName?.toUpperCase() !== touristPlan" class="blade-desc">
                  {{ aemContent?.perMonth }}
                </p>
              </div>
            </div>
            <ng-template #showSelectedPlan>
              <div class="row">
                <div class="col-9 col-md-9">
                  <h6
                    class="title space"
                    [ngClass]="{
                      'alert-text':
                        (selectedPlanFamilyCode === family?.familyCode ||
                          family?.planFamilySelected) &&
                        !isAddAFan,
                    }"
                  >
                    <i
                      *ngIf="
                        (selectedPlanFamilyCode === family?.familyCode ||
                          family?.planFamilySelected) &&
                        !isAddAFan
                      "
                      class="fa fa-check alert-icon def p-t-xs"
                    ></i>
                    {{ family?.familyName }}
                  </h6>
                  <p
                    class="blade-desc alert-text"
                    [ngClass]="{
                      'alert-text':
                        (selectedPlanFamilyCode === family?.familyCode ||
                          family?.planFamilySelected) &&
                        !isAddAFan,
                    }"
                    *ngIf="
                      (selectedPlanFamilyCode === family?.familyCode ||
                        family?.planFamilySelected) &&
                        !isAddAFan &&
                        selectedPlanName?.label;
                      else showPreselectedPlan
                    "
                  >
                    {{ selectedPlanName?.label }}
                  </p>
                  <ng-template #showPreselectedPlan>
                    <p
                      class="blade-desc alert-text"
                      [ngClass]="{
                        'alert-text':
                          (selectedPlanFamilyCode === family?.familyCode ||
                            family?.planFamilySelected) &&
                          !isAddAFan,
                      }"
                      *ngIf="
                        selectedPlanFamilyCode === family?.familyCode || family?.planFamilySelected
                      "
                    >
                      {{ selectedPlanLabel }}
                    </p>
                  </ng-template>
                  <p
                    class="blade-desc alert-text"
                    [ngClass]="{
                      'alert-text':
                        (selectedPlanFamilyCode === family?.familyCode ||
                          family?.planFamilySelected) &&
                        !isAddAFan,
                    }"
                    *ngIf="
                      !isAuthFlow &&
                      !disablePlanBlade &&
                      selectedPlanFamilyCode !== family?.familyCode &&
                      !family?.planFamilySelected &&
                      !isAddAFan
                    "
                  >
                    {{ aemContent?.noPlanSelected }}
                  </p>
                </div>
                <div
                  class="col-md-2 d-none d-md-block n-padding-l text-end"
                  *ngIf="
                    (selectedPlanFamilyCode === family?.familyCode || family?.planFamilySelected) &&
                    !isNoPlanNeeded
                  "
                >
                  <p class="lead m-t-xs">
                    {{
                      selectedPlanName?.monthlyPrice?.displayValue ||
                        selectedAmount ||
                        focusedTileId?.plansFromCart?.salesPrice | currency: 'USD' : 'symbol'
                    }}
                  </p>
                  <p *ngIf="family?.familyName?.toUpperCase() !== touristPlan" class="blade-desc">
                    {{ aemContent?.perMonth }}
                  </p>
                </div>
              </div>
            </ng-template>
          </p-header>
          <div class="p-content">
            <p class="bold row">{{ family?.familyName }}</p>
            <p class="m-t-xs row" *ngIf="family?.description">{{ family?.description }}</p>
            <div
              class="row"
              [ngClass]="i === 0 ? 'm-t-lg' : 'm-t-sm'"
              *ngFor="let plan of family.planOptions; let i = index"
            >
              <div class="col-12">
                <p
                  class="m-b-md bold row"
                  *ngIf="plan?.isActive && !isAddAFan && !isAccountSegmentationConflict"
                >
                  {{ aemContent?.active }}
                </p>
              </div>
              <div *ngIf="!isCPS && !!plan?.bannerText" class="col-12 m-l-md m-b-sm">
                <div class="triangle-flag icon-text">
                  <p id="feature-icon" class="legal">{{ plan?.bannerText }}</p>
                </div>
              </div>
              <div [ngClass]="{ 'col-9 col-md-7': !isCPS, 'col-9': isCPS }">
                <div class="row">
                  <tmo-radio-button
                    name="'familyPlans'"
                    aria-label="{{ plan?.label }} {{ aemContent?.optionSelectedFor }} {{
                      family?.familyCode
                    }}"
                    (onSelect)="
                      updateSelectedPlan(
                        plan,
                        family.familyCode,
                        family.familyId,
                        family.planConfigurationId,
                        plan.planOptionSelectorId
                      )
                    "
                    class="pull-left"
                    [selectedValue]="selectedPlanId"
                    [applySmallClass]="false"
                    [values]="plan?.planOptionSelectorId"
                    [id]="plan?.planOptionSelectorId"
                    >{{ plan?.label }}
                  </tmo-radio-button>
                </div>
                <div class="alert-text row">
                  <a *ngIf="showToolTip" class="tooltip-i">
                    <tmo-tooltip [text]="aemContent?.tooltipText"></tmo-tooltip>
                  </a>
                  <p class="content small m-t-xs" *ngIf="isAssistedFlow && plan?.attribute">
                    ({{ aemContent?.offerCode }}: {{ plan?.attribute }})
                  </p>
                  -->
                </div>
                <div class="alert-text row">
                  <p
                    class="content small m-t-sm"
                    *ngIf="selectedPlanId === plan?.planOptionSelectorId"
                  >
                    {{ plan?.shortDescription }}
                  </p>
                  <p
                    class="content m-t-sm"
                    *ngIf="!isProductSelector && selectedPlanId === plan?.planOptionSelectorId"
                  >
                    <a
                      href="javascript:void(0)"
                      class="small"
                      (click)="showSeeMoreModal($event)"
                      id="cta-default-143_{{ i }}"
                      >{{ aemContent?.seeMore }}</a
                    >
                  </p>
                </div>
              </div>
              <div [ngClass]="{ 'col-4': !isCPS, 'col-3': isCPS }" class="text-end">
                <p tabindex="-1" aria-label="" aria-hidden="true" class="lead">
                  {{ plan?.monthlyPrice?.displayValue | currency: 'USD' : 'symbol' }}
                </p>
                <p
                  *ngIf="family?.familyName?.toUpperCase() !== touristPlan"
                  tabindex="-1"
                  aria-label=""
                  aria-hidden="true"
                  class="xsmall m-t-xs"
                >
                  {{ aemContent?.perMonth }}
                </p>
              </div>
              <div>
                <p
                  class="alert-text legal col-11 m-t-sm"
                  *ngIf="
                    selectedPlanId === plan?.planOptionSelectorId &&
                    plan?.alternateDescriptions?.length
                  "
                >
                  {{ plan?.alternateDescriptions[0]?.text }}
                </p>
              </div>
              <div
                class="m-t-sm"
                *ngIf="
                  selectedPlanId === plan?.planOptionSelectorId &&
                  conflictingActiveServices &&
                  conflictingActiveServices.length > 0
                "
              >
                <div class="radio-check-spacer">
                  <p class="alert-text col-12" id="plans-conflict-message">
                    <i class="fa fa-flag def alert-icon"></i
                    >{{ conflictingPlanServicesNotification }}
                  </p>
                </div>
              </div>
            </div>
            <p class="row col-12 m-t-sm" *ngIf="!isCPS && !this.isProductSelector">
              <a
                href="javascript:void(0)"
                (click)="goToPlanDetail(family?.familyId)"
                id="cta-default-225_{{ familyIndex }}"
                >{{ aemContent?.learnMore }}</a
              >
            </p>
            <p class="small m-t-md m-l-xl" *ngIf="selectedPlanName?.alternateDescription">
              {{ selectedPlanName?.alternateDescription }}
            </p>
          </div>
        </p-accordionTab>
        <p-accordionTab
          [disabled]="disablePlanBlade"
          tmoRemoveRoleTab
          [ariaLabel]="grandFatheredPlans.categoryName"
          [selected]="!disablePlanBlade && selectedPlanFamilyCode === grandfatheredConst"
          class="fractional"
          *ngIf="
            grandFatheredPlans && grandFatheredPlans.family && grandFatheredPlans.family.length
          "
          id="p-accordionTab-default-41"
        >
          <p-header>
            <div class="row">
              <div class="col-9 col-md-9">
                <h6
                  class="title space"
                  id="title-plan"
                  [ngClass]="{
                    'alert-text': selectedPlanFamilyCode === grandfatheredConst && !isNoPlanNeeded,
                  }"
                >
                  <i
                    *ngIf="selectedPlanFamilyCode === grandfatheredConst"
                    class="fa fa-check alert-icon def icon-16 p-t-xs"
                  ></i>
                  {{ aemContent?.grandfathered }} {{ aemContent?.plans }}
                </h6>
                <p
                  class="blade-desc alert-text"
                  [ngClass]="{
                    'alert-text': selectedPlanFamilyCode === grandfatheredConst && !isNoPlanNeeded,
                  }"
                  id="selected-plan"
                  *ngIf="selectedPlanFamilyCode === grandfatheredConst"
                >
                  {{ selectedPlanName?.label }}
                </p>
                <p
                  class="blade-desc alert-text"
                  [ngClass]="{
                    'alert-text': selectedPlanFamilyCode === grandfatheredConst && !isNoPlanNeeded,
                  }"
                  *ngIf="
                    !isAuthFlow &&
                    !disablePlanBlade &&
                    !isNoPlanNeeded &&
                    selectedPlanFamilyCode !== grandfatheredConst
                  "
                >
                  {{ aemContent?.noPlanSelected }}
                </p>
              </div>
              <div
                [ngClass]="{ 'col-md-2': !isCPS, 'col-md-3': isCPS }"
                class="d-none d-md-block"
                *ngIf="selectedPlanFamilyCode === grandfatheredConst"
              >
                <p tabindex="-1" aria-label="" aria-hidden="true" class="lead m-t-xs">
                  {{ selectedPlanName?.monthlyPrice.displayValue | currency: 'USD' : 'symbol' }}
                </p>
                <p
                  *ngIf="family?.familyName?.toUpperCase() !== touristPlan"
                  tabindex="-1"
                  aria-label=""
                  aria-hidden="true"
                  class="blade-desc"
                >
                  {{ aemContent?.perMonth }}
                </p>
              </div>
            </div>
          </p-header>
          <div class="p-content">
            <div
              class="row"
              [ngClass]="{
                'm-t-xl': idx !== 0,
                'm-t-md': idx === 0 && selectedPlanFamilyCode === grandfatheredConst,
              }"
              *ngFor="let family of grandFatheredPlans.family; let idx = index"
            >
              <div class="col-12">
                <p class="row bold">{{ family?.familyName }} ({{ aemContent?.grandfathered }})</p>
                <p class="row m-t-xs m-b-xs">{{ family?.description }}</p>
                <p class="row col-12 m-t-sm" *ngIf="!isCPS && !this.isProductSelector">
                  <a
                    href="javascript:void(0)"
                    (click)="goToPlanDetail(family?.familyId)"
                    id="cta-default-145_{{ idx }}"
                    >{{ aemContent?.learnMore }}</a
                  >
                </p>
                <div class="row" *ngFor="let plan of family.planOptions; let i = index">
                  <p
                    class="m-t-md col-12 bold"
                    *ngIf="plan?.isActive && !isAddAFan && !isAccountSegmentationConflict"
                  >
                    {{ aemContent?.active }}
                  </p>

                  <div class="col-md-9" [ngClass]="i === 0 ? 'm-t-lg' : 'm-t-sm'">
                    <div class="row">
                      <tmo-radio-button
                        name="'familyPlans'"
                        class="pull-left"
                        (onSelect)="
                          updateSelectedPlan(
                            plan,
                            grandfatheredConst,
                            family.familyId,
                            family.planConfigurationId,
                            plan.planOptionSelectorId
                          )
                        "
                        [selectedValue]="selectedPlanId"
                        [applySmallClass]="false"
                        [values]="plan?.planOptionSelectorId"
                        [id]="plan?.planOptionSelectorId"
                        >{{ plan?.label }}
                      </tmo-radio-button>
                    </div>
                    <div class="alert-text row">
                      <a *ngIf="showToolTip" class="tooltip-i">
                        <tmo-tooltip [text]="aemContent?.tooltipText"></tmo-tooltip>
                      </a>
                      <p class="content small m-t-xs" *ngIf="isAssistedFlow">
                        ({{ aemContent?.offerCode }}: {{ plan?.attribute }})
                      </p>
                      <p
                        class="content small m-t-sm"
                        *ngIf="selectedPlanId === plan?.planOptionSelectorId"
                      >
                        {{ plan?.shortDescription }}
                      </p>
                      <p
                        class="content m-t-sm"
                        *ngIf="
                          (isPrepaid || isCPS) && selectedPlanId === plan?.planOptionSelectorId
                        "
                      >
                        <a
                          href="javascript:void(0)"
                          class="small"
                          (click)="showSeeMoreModal($event)"
                          id="cta-default-146_{{ i }}"
                          >{{ aemContent?.seeMore }}</a
                        >
                        <br />
                      </p>
                    </div>
                  </div>
                  <div class="col-md-3 text-end m-t-md n-padding-l">
                    <p tabindex="-1" aria-label="" aria-hidden="true" class="lead">
                      {{ plan?.monthlyPrice?.displayValue | currency: 'USD' : 'symbol' }}
                    </p>
                    <p
                      *ngIf="family?.familyName?.toUpperCase() !== touristPlan"
                      tabindex="-1"
                      aria-label=""
                      aria-hidden="true"
                      class="xsmall m-t-xs"
                    >
                      {{ aemContent?.perMonth }}
                    </p>
                  </div>
                  <p
                    class="alert-text legal m-t-sm"
                    *ngIf="
                      !isProductSelector &&
                      selectedPlanId === plan?.planOptionSelectorId &&
                      plan?.alternateDescriptions?.length
                    "
                  >
                    {{ plan?.alternateDescriptions[0]?.text }}
                  </p>
                  <div
                    class="m-t-sm"
                    *ngIf="
                      selectedPlanId === plan?.planOptionSelectorId &&
                      conflictingActiveServices &&
                      conflictingActiveServices.length > 0
                    "
                  >
                    <div class="radio-check-spacer">
                      <p class="alert-text col-9" id="grandfathered-plans-conflict-message">
                        <i class="fa fa-flag def alert-icon"></i
                        >{{ conflictingPlanServicesNotification }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-accordionTab>
      </p-accordion>

      <div
        class="m-t-lg"
        *ngIf="isProductSelector && familyPlanData?.length > 0 && !disablePlanBlade"
      >
        <a
          href="javascript:void(0)"
          (click)="goToBrowsePlans()"
          class="m-t-md"
          id="cta-default-147"
          >{{ aemContent?.seeAllCompatiblePlans }}</a
        >
      </div>

      <ng-template #elseBlock>
        <p class="col-12 error-text" *ngIf="noResults">
          <i class="fa fa-exclamation-circle def error-icon"></i>{{ aemContent?.noResultsFound }}
        </p>
      </ng-template>
    </div>

    <ng-template #digitalPlansView>
      <div
        class="container-fluid outer-div m-t-xl"
        *ngIf="familyPlanData && familyPlanData.length > 0"
      >
        <h3 *ngIf="!showConnectPlans" class="m-b-xl text-center">{{ planHeader }}</h3>
        <ul class="nav nav-pills inner-flex row mb-3" role="tablist">
          <li
            *ngIf="tmobilePrepaidPlanOptions && !showConnectPlans"
            class="col-sm-12 col-md-12 col-lg-4"
          >
            <a
              class="nav-link"
              [ngClass]="{
                active:
                  id === sharedBrowseConstants?.TMOBILE_PREPAID_PLAN ||
                  id === sharedBrowseConstants?.TMO_PREPAID_CORE_OFFER_FAMILY_NAME,
                disable: disablePlanBlade,
              }"
              (click)="selectedplanFamily(sharedBrowseConstants?.TMOBILE_PREPAID_PLAN)"
              data-toggle="pill"
              role="tab"
              aria-controls="pills-home"
              aria-selected="true"
              >{{ aemContent?.unlimitedDataPlans }}</a
            >
          </li>
          <li
            *ngIf="connectByTmoPlanDetails && !showConnectPlans && isLoggedIn"
            class="col-sm-12 col-md-12 col-lg-4"
          >
            <a
              class="nav-link"
              [ngClass]="{
                active:
                  id === sharedBrowseConstants?.CONNECT_BY_TMOBILE ||
                  id === sharedBrowseConstants?.CONNECT_BY_TMO_CORE_OFFER_FAMILY_NAME,
                disable: disablePlanBlade,
              }"
              (click)="selectedplanFamily(sharedBrowseConstants?.CONNECT_BY_TMOBILE)"
              data-toggle="pill"
              role="tab"
              aria-controls="pills-home"
              aria-selected="false"
              >{{ aemContent?.limitedDataPlans }}</a
            >
          </li>
          <li
            *ngIf="mobileInternetPlanOptions && !showConnectPlans"
            class="col-sm-12 col-md-12 col-lg-4"
          >
            <a
              class="nav-link"
              [ngClass]="{
                active:
                  id === sharedBrowseConstants?.MOBILE_INTERNET_PLAN ||
                  id === sharedBrowseConstants?.MOBILE_INTERNET_CORE_OFFER_FAMILY_NAME,
                disable: disablePlanBlade,
              }"
              (click)="selectedplanFamily(sharedBrowseConstants?.MOBILE_INTERNET_PLAN)"
              data-toggle="pill"
              role="tab"
              aria-controls="pills-home"
              aria-selected="false"
              >{{ aemContent?.dataOnlyPlans }}</a
            >
          </li>
        </ul>

        <div class="tab-content" *ngIf="!disablePlanBlade; else addALineDisabled">
          <div
            [ngClass]="
              id === sharedBrowseConstants?.TMOBILE_PREPAID_PLAN ||
              id === sharedBrowseConstants?.TMO_PREPAID_CORE_OFFER_FAMILY_NAME
                ? 'tab-pane fade show active'
                : 'tab-pane fade'
            "
            role="tabpanel"
          >
            <tmo-unlimited-data-plans
              [fccLabelLinkText]="fccLabelLinkText"
              [fccLabelLinkUrl]="fccLabelLinkUrl"
              [familyPlanOptions]="tmobilePrepaidPlanOptions"
              [tmobilePrepaidPlanDetails]="tmobilePrepaidPlanDetails"
              [isProductSelector]="isProductSelector"
              [isAddAFan]="isAddAFan"
              [selectedPlanFamilyCode]="selectedPlanFamilyCode"
              [aemContent]="aemContent"
              [selectedPlanName]="selectedPlanName"
              [noPlanNeeded]="noPlanNeeded"
              [planId]="selectedPlanId"
              [isEdit]="isEdit"
              [promotionTagIconTemplate]="promotionTagIconTemplate"
              [planPromotions]="planPromotions"
              [autopayDiscountDetailsModal]="autopayDiscountDetailsModal"
              [showAutoPayDiscountContent]="autoPayDiscountEnabled"
              (selectedPlan)="
                updateSelectedPlan(
                  $event,
                  tmobilePrepaidPlanDetails?.familyCode,
                  tmobilePrepaidPlanDetails?.familyId,
                  tmobilePrepaidPlanDetails?.planConfigurationId,
                  $event?.planOptionSelectorId
                )
              "
              (routeToCart)="routeToCart($event)"
              (showPlanDetailModal)="openPlanDetailModal($event)"
              [isCPS]="isCPS"
            >
            </tmo-unlimited-data-plans>
          </div>
          <div
            [ngClass]="
              id === sharedBrowseConstants?.CONNECT_BY_TMOBILE ||
              id === sharedBrowseConstants?.CONNECT_BY_TMO_CORE_OFFER_FAMILY_NAME
                ? 'tab-pane fade show active'
                : 'tab-pane fade'
            "
            role="tabpanel"
          >
            <tmo-limited-data-plans
              [fccLabelLinkText]="fccLabelLinkText"
              [fccLabelLinkUrl]="fccLabelLinkUrl"
              [planFamilyDetails]="connectByTmoPlanDetails"
              [familyPlanOptions]="connectByTmoPlanOptions"
              [isProductSelector]="isProductSelector"
              [isAddAFan]="isAddAFan"
              (showPlanDetailModal)="openPlanDetailModal($event)"
              [selectedPlanId]="selectedPlanId"
              [selectedPlanFamilyCode]="selectedPlanFamilyCode"
              [aemContent]="aemContent"
              [selectedPlanName]="selectedPlanName"
              [noPlanNeeded]="noPlanNeeded"
              [promotionTagIconTemplate]="promotionTagIconTemplate"
              [planPromotions]="planPromotions"
              [autopayDiscountDetailsModal]="autopayDiscountDetailsModal"
              [showAutoPayDiscountContent]="autoPayDiscountEnabled"
              (selectedPlan)="
                updateSelectedPlan(
                  $event,
                  connectByTmoPlanDetails?.familyCode,
                  connectByTmoPlanDetails?.familyId,
                  connectByTmoPlanDetails?.planConfigurationId,
                  $event?.planOptionSelectorId
                )
              "
              (routeToCart)="routeToCart($event)"
              [isCPS]="isCPS"
            >
            </tmo-limited-data-plans>
          </div>
          <div
            [ngClass]="
              id === sharedBrowseConstants?.MOBILE_INTERNET_PLAN ||
              id === sharedBrowseConstants?.MOBILE_INTERNET_CORE_OFFER_FAMILY_NAME
                ? 'tab-pane fade show active'
                : 'tab-pane fade'
            "
            role="tabpanel"
          >
            <tmo-data-only-plans
              [fccLabelLinkText]="fccLabelLinkText"
              [fccLabelLinkUrl]="fccLabelLinkUrl"
              [familyPlanOptions]="mobileInternetPlanOptions"
              [isProductSelector]="isProductSelector"
              [isAddAFan]="isAddAFan"
              [selectedPlanFamilyCode]="selectedPlanFamilyCode"
              [selectedPlanId]="selectedPlanId"
              [aemContent]="aemContent"
              [selectedPlanName]="selectedPlanName"
              [noPlanNeeded]="noPlanNeeded"
              [isEdit]="isEdit"
              [planFamilyDetails]="mobileInternetPlanDetails"
              [promotionTagIconTemplate]="promotionTagIconTemplate"
              [planPromotions]="planPromotions"
              [autopayDiscountDetailsModal]="autopayDiscountDetailsModal"
              [showAutoPayDiscountContent]="autoPayDiscountEnabled"
              (showPlanDetailModal)="openPlanDetailModal($event)"
              (selectedPlan)="
                updateSelectedPlan(
                  $event,
                  mobileInternetPlanDetails?.familyCode,
                  mobileInternetPlanDetails?.familyId,
                  mobileInternetPlanDetails?.planConfigurationId,
                  $event?.planOptionSelectorId
                )
              "
              (routeToCart)="routeToCart($event)"
              [isCPS]="isCPS"
            >
            </tmo-data-only-plans>
          </div>
          <!-- <div>
            <tmo-no-plan-needed *ngIf="(!isByos && !isByod)" [aemContent]="aemContent"
              [noPlanNeeded]="noPlanNeeded"
              [disableCheckbox]="(isMaxlinesReached || !hasRepPermissionToAddFirstLine)&& focusedTileIdDetails?.lineTileType === 1"
              (isNoPlanSelected)="updateNoPlanSelected($event)" [isPlanAdded]="focusedTileIdDetails?.plansFromCart?.id"
              [focusedTileIdDetails]="focusedTileIdDetails">
            </tmo-no-plan-needed>
          </div>
          <p></p> -->
        </div>
        <ng-template #addALineDisabled>
          <div class="row">
            <div class="col-12 text-center">
              <div class="text-center m-b-xl">
                <p *ngIf="isAuthFlow">{{ aemContent?.lineInAccount }}</p>
                <p *ngIf="!isAuthFlow">{{ aemContent?.lineInCart }}</p>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </ng-template>
  </div>
  <tmo-spinner [setDelay]="!showSpinner"></tmo-spinner>

  <tmo-dynamic-modal [modal]="modal" (onHide)="closeModal()">
    <ng-container header>
      <div class="modal-logo-close">
        <i class="logo-icon t-icon t-icon-logo" *ngIf="!isNewProductSelectorTemplateEnabled"></i>
        <a
          tabindex="0"
          [attr.aria-label]="aemContent?.clickToClose"
          href="javascript:void(0)"
          class="close-x pull-right"
          (click)="closeModal()"
          id="cta-click-to-close-6"
        >
          <i class="fa fa-times"></i>
        </a>
      </div>
      <div class="row">
        <div [ngClass]="isNewProductSelectorTemplateEnabled ? 'col-12 p-l-sm' : 'col-8'">
          <h3>{{ selectedPlanName?.label }}</h3>
        </div>
        <div class="col-4 m-t-lg text-end" *ngIf="!isNewProductSelectorTemplateEnabled">
          <p tabindex="-1" aria-label="" aria-hidden="true" class="lead">
            {{ selectedPlanName?.monthlyPrice?.displayValue | currency: 'USD' : 'symbol' }}
          </p>
          <p tabindex="-1" aria-label="" aria-hidden="true" class="xsmall">
            {{ aemContent?.perMonth }}
          </p>
        </div>
        <!-- <div class="col-12 m-t-sm" *ngIf="isAssistedFlow">
          <p class="small">({{aemContent?.offerCode}}: {{selectedPlanName?.attribute}})</p>
        </div> -->
      </div>
    </ng-container>
    <p class="lead bold" *ngIf="!isNewProductSelectorTemplateEnabled">
      {{ aemContent?.planDescription }}
    </p>
    <p class="small m-t-sm">{{ selectedPlanName?.longDescription }}</p>
    <p
      class="xsmall m-t-lg"
      *ngIf="
        selectedPlanName?.alternateDescriptions?.length && !isNewProductSelectorTemplateEnabled
      "
    >
      {{ selectedPlanName?.alternateDescriptions[0]?.text }}
    </p>
    <ng-container footer> </ng-container>
  </tmo-dynamic-modal>
</div>
<tmo-static-modal [modal]="mixedCartModal" (onSelect)="handleClickEvent($event)"></tmo-static-modal>
